module.exports = __webpack_public_path__ + "static/img/balz909-663-37083.4813f1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balz909-663-37083.jpg
// module id = Or94
// module chunks = 0